export default __webpack_public_path__ + "static/media/CClogo.98789c95.png";